import { Link } from "react-router-dom";
import { Seo } from "@/components/seo/Seo";

const NotFound = () => (
  <div className="pt-48 pb-40 max-w-7xl mx-auto px-6 md:px-12" data-testid="not-found">
    <Seo title="Page not found" description="That page doesn't exist." noindex />
    <p className="label-eyebrow text-[#38BDF8]">404</p>
    <h1 className="mt-6 font-display uppercase text-5xl md:text-7xl tracking-tight leading-[0.9] text-[#2E1B16]">That page isn't <span className="font-accent font-normal normal-case text-[#38BDF8]">here.</span></h1>
    <p className="mt-8 text-lg text-[#2E1B16]/60 max-w-md">It may have moved. Try the homepage or have a look at our work.</p>
    <div className="mt-10 flex gap-6">
      <Link to="/" className="font-semibold text-[#2E1B16] link-underline px-2 py-2">Homepage</Link>
      <Link to="/work" className="font-semibold text-[#2E1B16] link-underline px-2 py-2">Our work</Link>
    </div>
  </div>
);

export default NotFound;
